<template>
  <b-form-checkbox
    v-if="show"
    v-model="toggle"
    value="true"
    unchecked-value="false"
    >Show / Hide All</b-form-checkbox
  >
</template>

<script>
export default {
  name: "ShowHideCheckbox",
  props: ["show"],
  data: function() {
    return {
      toggle: false
    };
  },
  watch: {
    toggle(param) {
      this.$emit("toggleData", param);
    }
  },
  computed: {}
};
</script>
